<script>
import resourceSelect from '../../mixins/resourceSelect';

export default {
  mixins: [resourceSelect],

  data() {
    return {
      route: 'api.customers.index',
      defaults: {
        trackBy: 'id',
        label: 'name',
        placeholder: 'Sélectionnez un client',
      },
    };
  },
};
</script>